import { createFileRoute } from "@tanstack/react-router";
import AdminSetQuestionDetailPage from "@/pages/admin/sets/detail/questions/detail";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/questions/$questionId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId, questionId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms, userCanViewAllCriteria } = useSetsPermissions();

  return (
    <AdminSetQuestionDetailPage
      questionId={Number(questionId)}
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanViewAllCriteria={userCanViewAllCriteria}
    />
  );
}
